import { Wrench, CalendarCheck } from '@phosphor-icons/react';

export function EquipmentAlerts({ alerts }) {
  if (!alerts || alerts.length === 0) return null;

  return (
    <div className="bg-white rounded-xl p-4 sm:p-6 border-2 border-red-200 mb-6" data-testid="equipment-alerts">
      <div className="flex items-center gap-2 mb-4">
        <Wrench size={20} weight="fill" className="text-red-500" />
        <h2 className="text-base sm:text-lg font-semibold text-slate-900" style={{ fontFamily: 'Outfit' }}>
          Equipment Maintenance Alerts
          <span className="ml-2 px-2 py-0.5 rounded-full text-xs bg-red-100 text-red-800 font-bold">{alerts.length}</span>
        </h2>
      </div>
      <div className="space-y-2">
        {alerts.map(alert => (
          <div key={alert.asset_tag} className={`flex items-center justify-between p-3 rounded-lg border ${alert.severity === 'overdue' ? 'border-red-200 bg-red-50' : 'border-amber-200 bg-amber-50'}`}
            data-testid={`equip-alert-${alert.asset_tag}`}>
            <div className="flex items-center gap-3 min-w-0">
              {alert.type === 'calibration' ? <CalendarCheck size={18} className={alert.severity === 'overdue' ? 'text-red-600' : 'text-amber-600'} /> : <Wrench size={18} className={alert.severity === 'overdue' ? 'text-red-600' : 'text-amber-600'} />}
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-medium text-sm text-slate-900 truncate">{alert.name}</span>
                  <span className="text-xs font-mono text-slate-500">{alert.asset_tag}</span>
                </div>
                <div className="text-xs text-slate-600 mt-0.5">
                  {alert.type === 'calibration' ? 'Calibration' : 'Service'} {alert.severity === 'overdue' ? 'was due' : 'due'}: <span className="font-semibold">{alert.date}</span>
                </div>
              </div>
            </div>
            <span className={`px-2 py-0.5 rounded-full text-xs font-bold shrink-0 ${alert.severity === 'overdue' ? 'bg-red-200 text-red-800' : 'bg-amber-200 text-amber-800'}`}>
              {alert.severity === 'overdue' ? 'OVERDUE' : 'UPCOMING'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
